define(["require", "exports"], function (require, exports) {
    "use strict";
    var _a, _b, _c;
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isNonProduction = exports.isPublicZone = exports.defaultBrowserLanguage = exports.featuresFromSearchParam = exports.navigationsFromSearchParam = exports.pluginsFromSearchParam = exports.navigationsSetFromSearchParam = exports.maintenanceFromSearchParam = exports.maintenanceOverrideFromSearchOrSession = exports.maintenanceOverrideFromConfig = exports.configFromSessionStorage = exports.configFromSearchParam = exports.pluginSearchParams = exports.debug = exports.isDebugOn = exports.requestedLanguage = exports.normalizeLanguage = exports.isSupportedLanguage = exports.supportedLanguages = exports.apiUrl = void 0;
    exports.apiUrl = process.env.API_PATH || "/api";
    exports.supportedLanguages = [
        "cs", "de", "en", "es", "es-mx", "fr", "fr-ca", "hu", "it", "ja", "ko", "pl", "pt", "pt-br", "ro", "ru", "zh-cn", "zh-tw"
    ];
    const isSupportedLanguage = (language, disabled = []) => {
        if (!language) {
            return false;
        }
        const lang = language.toLowerCase();
        return exports.supportedLanguages.includes(lang) && !disabled.includes(lang);
    };
    exports.isSupportedLanguage = isSupportedLanguage;
    const normalizeLanguage = (language, disabled = []) => {
        const raw = (language || "").toLowerCase().replace("_", "-");
        if (raw === "zh") {
            return "zh-cn";
        }
        if (raw.startsWith("zh-")) {
            if (raw.includes("tw") || raw.includes("hant")) {
                return (0, exports.isSupportedLanguage)("zh-tw", disabled) ? "zh-tw" : "en";
            }
            return (0, exports.isSupportedLanguage)("zh-cn", disabled) ? "zh-cn" : "en";
        }
        const base = raw.split("-")[0];
        const candidate = exports.supportedLanguages.find(l => l === raw) || exports.supportedLanguages.find(l => l === base) || "en";
        return (0, exports.isSupportedLanguage)(candidate, disabled) ? candidate : "en";
    };
    exports.normalizeLanguage = normalizeLanguage;
    exports.requestedLanguage = (() => {
        const value = new URLSearchParams(window.location.search).get("language");
        const sanitized = value === null || value === void 0 ? void 0 : value.trim().toLowerCase().replace(/_/g, "-").replace(/[^a-z-]/g, "");
        return (0, exports.isSupportedLanguage)(sanitized) ? sanitized : undefined;
    })();
    exports.isDebugOn = new URLSearchParams(window.location.search).get("debug") === "true";
    const debug = (message, ...optionalParams) => {
        if (exports.isDebugOn) {
            console.info(message, ...optionalParams);
        }
    };
    exports.debug = debug;
    const pluginSearchParams = () => {
        const allowedPluginSearchParams = [
            "accountId", "p", "cs", "selectedTab", "selected_tab", "expertise_id", "sel_geo", "company_id", "sel_track", "sel_pillar", "sel_sub_pillar",
            "companyId", "prinCompanyName", "prinCompanyId", "myCompName", "startDate", "endDate", "track_id", "geo_id", "advanced_publish",
            "track", "publish", "eligible", "inProgress", "ooc", "mse", "csse", "action", "refresh", "par_company_id", "selectedSearchBy",
            "searchBy", "extCid", "headerId", "UCO_HEADER_ID", "invoiceNumber"
        ];
        const pluginSearchParams = {};
        const allSearchParams = new URLSearchParams(window.location.search);
        for (const [key, value] of allSearchParams.entries()) {
            if (allowedPluginSearchParams.some(asp => asp === key)) {
                pluginSearchParams[key] = value;
            }
        }
        return new URLSearchParams(pluginSearchParams);
    };
    exports.pluginSearchParams = pluginSearchParams;
    exports.configFromSearchParam = (() => {
        const config = JSON.parse(new URLSearchParams(window.location.search).get("config"));
        if (config !== null) {
            sessionStorage.setItem("config", JSON.stringify(config));
        }
        return config;
    })();
    exports.configFromSessionStorage = JSON.parse(sessionStorage.getItem("config") || "{}");
    const maintenanceOverrideFromConfig = (config) => {
        if (config === null || typeof config !== "object") {
            return {};
        }
        const configObject = config;
        const override = {};
        if (Object.prototype.hasOwnProperty.call(configObject, "maintenanceStart") && typeof configObject.maintenanceStart === "string") {
            override.maintenanceStart = configObject.maintenanceStart;
        }
        if (Object.prototype.hasOwnProperty.call(configObject, "maintenanceEnd") && typeof configObject.maintenanceEnd === "string") {
            override.maintenanceEnd = configObject.maintenanceEnd;
        }
        return override;
    };
    exports.maintenanceOverrideFromConfig = maintenanceOverrideFromConfig;
    const maintenanceOverrideFromSearchOrSession = (searchConfig, sessionConfig) => (0, exports.maintenanceOverrideFromConfig)(searchConfig !== null ? searchConfig : sessionConfig);
    exports.maintenanceOverrideFromSearchOrSession = maintenanceOverrideFromSearchOrSession;
    exports.maintenanceFromSearchParam = (0, exports.maintenanceOverrideFromSearchOrSession)(exports.configFromSearchParam, exports.configFromSessionStorage);
    exports.navigationsSetFromSearchParam = (exports.configFromSearchParam !== null && exports.configFromSearchParam.hasOwnProperty("navigationsSet"))
        ? exports.configFromSearchParam["navigationsSet"]
        : exports.configFromSessionStorage.navigationsSet;
    exports.pluginsFromSearchParam = (exports.configFromSearchParam !== null && exports.configFromSearchParam.hasOwnProperty("plugins"))
        ? exports.configFromSearchParam["plugins"]
        : (_a = exports.configFromSessionStorage.plugins) !== null && _a !== void 0 ? _a : [];
    exports.navigationsFromSearchParam = (exports.configFromSearchParam !== null && exports.configFromSearchParam.hasOwnProperty("navigations"))
        ? exports.configFromSearchParam["navigations"]
        : (_b = exports.configFromSessionStorage.navigations) !== null && _b !== void 0 ? _b : [];
    exports.featuresFromSearchParam = (exports.configFromSearchParam !== null && exports.configFromSearchParam.hasOwnProperty("features"))
        ? exports.configFromSearchParam["features"]
        : (_c = exports.configFromSessionStorage.features) !== null && _c !== void 0 ? _c : {};
    exports.defaultBrowserLanguage = (() => {
        var _a, _b, _c;
        return ((_c = (_b = (_a = navigator.languages) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : navigator.language) !== null && _c !== void 0 ? _c : "en").toLowerCase();
    })();
    const isPublicZone = (environment) => environment === null || environment === void 0 ? void 0 : environment.features.publicZone.map(p => p.path).some(publicPath => window.location.pathname.match(publicPath.replace(/\/:[a-zA-Z]+?\b/, "/.+").replace("/*", "/.+")));
    exports.isPublicZone = isPublicZone;
    const isNonProduction = () => ["localhost", "dev", "sit", "test", "stage"].some(env => window.location.origin.includes(env));
    exports.isNonProduction = isNonProduction;
});
